<template>
  <div class="u-wrap">
    <div class="card" v-for="(item, index) in navList" :key="index">
      <div class="card-title">
        <p>{{ item.title }}</p>
      </div>
      <van-grid clickable :column-num="4" :border="false">
        <van-grid-item v-for="(itm, idx) in item.list" :key="idx" @click="goPage(itm)">
          <div v-if="itm.type != 6 && itm.type != 7 && itm.type != 8" class="xbox1">
            <img :src="itm.icon" class="grid-img" />
            <div class="grid-text1">{{ itm.title }}</div>
          </div>
          <div v-if="itm.type == 7">
            <van-grid-item>
              <img src="@images/icon2/ydjy.png" class="grid-img" />
              <div class="grid-text1">异地就医</div>
              <van-grid-item class="btn11">
                <wx-open-launch-weapp id="launch-btn1" username="gh_95fd1700c01e" path="pages/common/launch-screen">
                  <script type="text/wxtag-template">
                       <style>.xbox{width: 100%;height:100%;display: flex;justify-content: center;flex-wrap: wrap;}.btn { border: 0;outline: none;opacity:0;-webkit-tap-highlight-color:transparent !important;font-size: 12px;text-align: center;width: 100%;height:80px}</style>
                       <div class="xbox">
                    <div class="btn">异地就医</div>
                       </div>
                  </script>
                </wx-open-launch-weapp>
              </van-grid-item>
            </van-grid-item>
          </div>
          <div v-if="itm.type == 8">
            <van-grid-item>
              <img src="@images/icon2/cccx.png" class="grid-img" />
              <div class="grid-text1">车次查询</div>
              <van-grid-item class="btn11">
                <wx-open-launch-weapp id="launch-btn1" username="gh_a982e843b128" path="pages/bus/index/index">
                  <script type="text/wxtag-template">
                       <style>.xbox{width: 100%;height:100%;display: flex;justify-content: center;flex-wrap: wrap;}.btn { border: 0;outline: none;opacity:0;-webkit-tap-highlight-color:transparent !important;font-size: 12px;text-align: center;width: 100%;height:80px}</style>
                       <div class="xbox">
                    <div class="btn">车次查询</div>
                       </div>
                  </script>
                </wx-open-launch-weapp>
              </van-grid-item>
            </van-grid-item>
          </div>
        </van-grid-item>

        
      </van-grid>
    </div>
      <SmrzPop v-model="show" />
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import FileMixin from '@/views/common/mixins/file-mixin.js'
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import navList1 from './moreList.js'
import wx from 'weixin-js-sdk'
import { getGenderByIdNumber, strToUtf8Bytes, strToHexCharCode } from '@/utils/util'
import SmrzPop from '../common/smrz-pop.vue'
export default {
  name: 'more',
  components: { SmrzPop },
  mixins: [FileMixin, OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  data() {
    return {
      navList: [],
      wxHtml1: '',
      wxHtml2: '',
      wxHtml3: '',
      showXfsf: false,
      show:false,
    }
  },
  created() {
    this.navList = navList1
    console.log('navList', this.navList)
    this.initWxInfo()
  },
  methods: {
    initData() {
      let openid = this.$store.getters.openId
      let params = { openid }
      getAction('/zhshj/xxsf/xfsf/gzhsfxs', params).then((res) => {
        if (res.success && res.message == '当前用户是重点人') {
          this.showXfsf = true
        } else {
          this.showXfsf = false
        }
      })
    },
    initWxInfo() {
      let that = this;
      // let urlHref = encodeURIComponent(window.location.href)
      let urlHref = encodeURIComponent(window.location.href.split('#')[0])
      let params = { url: urlHref }
      console.log(urlHref);
      let url = `/sys/mlogin/get/jsdk?url=${urlHref}`
      postAction(url, params).then((res) => {
        if (res.success) {
          let obj = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: obj.appId, // 必填，公众号的唯一标识
            timestamp: obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: obj.nonceStr, // 必填，生成签名的随机串
            signature: obj.signature, // 必填，签名，见附录1
            jsApiList: [
              'getLocation',
              'chooseImage',
              'startRecord',
              'stopRecord',
              'onVoiceRecordEnd',
              'playVoice',
              'onVoicePlayEnd',
              'pauseVoice',
              'stopVoice',
              'uploadVoice',
              'downloadVoice',
            ],
            openTagList: ['wx-open-launch-weapp'],
          })
        }
      })
      wx.ready(function () {
         if (that.isIos() && sessionStorage.getItem("go_xcx") == 1) {
                  window.location.reload();
                  sessionStorage.setItem('go_xcx', 2)
             }
      })
      wx.error(function () {
        console.log('config error0')
      })
    },
    goPage(itm) {
      if(itm.isSmrz&&!this.isSmrz()){
        this.show=true;
        return;
      }
      if (itm.type == 1) {
        this.$router.push({
          path: itm.path,
          query: itm.params,
        })
      }
      if (itm.type == 2) {
        //路径跳转
        this.$router.push({
          path: itm.path,
        })
      }
      if (itm.type == 3) {
        //路径h5链接
        if (itm.idx) {
          this.addTj(itm.idx)
          if(itm.idx=='10'){
            this.goWmsj();
          }
        }
        window.location.href = itm.path
      }
      if (itm.type == 4) {
        //小程序
      }
    },
    goPage1(itm) {
      this.getAddress(itm.path)
      // window.location.href = itm.path
    },
    getAddress(path) {
      var getAddr = new qq.maps.Geocoder({
        complete: function (res) {
          var address = res.detail.address
          // _this.model.address = address
          console.log(address)
        },
      })
      let _this = this
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (d) => {
          var latitude = d.latitude // 纬度，浮点数，范围为90 ~ -90
          var longitude = d.longitude // 经度，浮点数，范围为180 ~ -180。
          console.log(latitude + '==' + longitude)
          _this.handleLaunchYd(longitude, latitude, path)

          var latLng = new qq.maps.LatLng(d.latitude, d.longitude)
          getAddr.getAddress(latLng)
        },
        fail: (d) => {
          this.$toast('获取微信坐标位置失败，请点击右上角‘…’→刷新一下，谢谢配合！')
        },
      })
    },
    handleLaunchYd(jd, wd, path) {
      let openid = this.$store.getters.openId
      let params = { openid, jd, wd }

      getAction('/zhshj/xxsf/xfsf/gzh', params).then((res) => {
        window.location.href = path
      })
    },
    addTj(code) {
      let params = { gpfwmblx: code }
      getAction('/zhshj/gpfwmb/add/tj', params).then((res) => {
        if (res.suuccess) {
        }
      })
    },
    goWmsj() {
      let obj = this.getSmrzData()
      const mobile = obj.phone
      const name = obj.wechatName
      const idCard = obj.idNumber
      const sex = getGenderByIdNumber(obj.idNumber)
      let params = { name, sex, idCard, mobile }
      // let params ={"name":"测试","sex":1,"idCard":"37081119890826603X","mobile":"18678768992"}
      let hexCode = strToHexCharCode(strToUtf8Bytes(JSON.stringify(params)))
      const hexLowerCase = hexCode.toLocaleLowerCase()
      let path = `https://cwxxsd.deepoceanbd.com/h5?param=${hexLowerCase}`
      window.location.href = path;
    },
    isIos() {//判断是IOS还是Android
			var userAgent = navigator.userAgent;
			var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
			var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			if (isAndroid) {
				return false;
			} else if (isiOS) {
				return true;
			}
		},
  },
}
</script>

<style scoped lang="less">
.u-wrap {
  min-height: 100vh;
  display: flex;
  padding: 0px 10px 20px;
  flex-direction: column;
  background: #f6f6f6;
}
.card {
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  margin-top: 8px;
  padding: 12px 8px;
  overflow: hidden;
  &-title {
    margin: 0px 0px 4px;
    p {
      margin: 0px;
      position: relative;
      padding: 0px 0px 0px 10px;
      font-size: 14px;
    }
    p::before {
      content: '';
      width: 4px;
      height: 100%;
      position: absolute;
      left: 0px;
      top: 0px;
      background: #39a9ed;
    }
  }
}
.card2 {
  margin: 0px 8px 10px;
  padding: 12px 8px;
  .title {
    width: 100%;
    position: relative;
    margin: 0px 0px 10px;
    display: flex;
    box-sizing: border-box;
    padding: 0px 0px 0px 10px;
    justify-content: space-between;
    p {
      margin: 0px;
      padding: 0px;
      letter-spacing: 1px;
    }
    p:last-child {
      color: #999;
    }
  }
  .title::before {
    content: '';
    width: 4px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    background: #39a9ed;
  }
  &-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    div {
      width: 45%;
      height: 70px;
      display: flex;
      border: 1px solid #f3f3f3;
      margin: 0px 0px 10px;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  &-content2 {
    > div {
      display: flex;
      height: 80px;
      margin: 0px 0px 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      justify-content: space-between;
    }
    &-l {
      width: 80px;
      height: 80px;
      border: 1px solid #f3f3f3;
    }
    &-r {
      width: 70%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: space-between;
      p {
        margin: 0px;
        padding: 0px;
        font-size: 14px;
        overflow: hidden;
        line-height: 20px;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        display: -webkit-box;
      }
      p:first-child::before {
        content: 'new';
        line-height: 12px;
        display: inline-block;
        border-radius: 4px;
        font-size: 12px;
        background-color: #4d83fd;
        color: #fff;
        border: 1px solid #4d83fd;
        margin: 0px 6px 0px 0px;
        padding: 1px 3px;
      }
    }
  }
}
.csq {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
}

.flex-center {
  display: flex;
  align-items: center;
}

.text {
  font-size: 14px;
  color: #666666;
  margin-left: 10px;
}

.csq .value {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.grid-img {
  width: 40px;
  height: 40px;
}

.grid-img1 {
  width: 40px;
  height: 40px;
}

.grid-text {
  margin-top: 9px;
  font-size: 15px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 22px;
  text-align: center;
}

.line-2 {
  height: 44px;
}

.dt-title {
  text-align: center;
  line-height: 36px;
  font-size: 17px;
  color: #333333;
}

.line {
  margin: 0 12px;
  height: 1px;
  background-color: #ededed;
}

.ssdt-item {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #ededed;
}

.left-img {
  width: 38px;
  height: 38px;
  margin-top: 5px;
}

.right-content {
  flex: 1;
  margin-left: 10px;
}

.name {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}

.right-content .content {
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  height: 94px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.right-content .content2s {
  height: auto !important;
}

.right-content .time {
  color: #999;
  font-size: 14px;
}

.popup-content {
  width: 290px;
  height: 317px;
  position: relative;
}

.d-title {
  font-size: 18px;
  font-weight: 600;
  color: #3875f6;
  line-height: 25px;
  margin-top: 26px;
  text-align: center;
}

.d-content {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  line-height: 18px;
  margin: 16px 24px 32px;
  text-align: center;
}
.d-button {
  width: 80%;
  height: 38px;
  line-height: 38px;
  background: #3875f6;
  color: #ffffff;
  font-size: 15px;
  border-radius: 38px;
  margin-left: 10%;
  border: none;
}

.close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.dz-img {
  width: 16px;
  height: 16px;
}
.dz-text {
  color: #3875f6;
  margin-left: 6px;
}

.dz-content {
  margin-top: 7px;
  height: auto;
  background: #f6f6f6;
  padding: 8px;
  position: relative;
}

.dz-t {
  color: #3875f6;
  margin-left: 10px;
  line-height: 18px;
}

.sjx {
  border-bottom: 8px solid #f6f6f6;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  width: 1px;
  margin-left: 10px;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.lb {
  width: 15px;
  height: 14px;
  position: absolute;
  top: 13px;
  left: 12px;
}

.imgList {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}
.imgList .images {
  width: 80px;
  height: 80px;
  margin: 0 10px 10px 0;
}

.grid-text1 {
  font-size: 12px;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  width: 100%;
  text-align: center;
}

.title {
  font-size: 14px;
  font-weight: bold;
  padding-left: 12px;
}

::v-deep .van-grid-item__content {
  padding: 10px 4px;
  background-color: #fff;
}
.my-swipe .van-swipe-item {
  /* color: #fff; */
  font-size: 20px;
  width: 100%;
  text-align: center;
  background-color: white;
}
::v-deep .van-tab {
  font-size: 16px;
}
.my-swipe /deep/ .van-swipe__indicators {
  bottom: 0px;
}
.llhzc {
  display: flex;
  margin: 10px 8px;
  justify-content: space-between;
}
.llhzc img {
  width: 48%;
}
/* .wx-open-weapp {
  flex-basis: 25%;
  height: 70px;
} */
#launch-btn1,
#launch-btn2,
#launch-btn3 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color:transparent !important
}
.btn11 {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.btn11 /deep/ .van-grid-item__content {
  height: 70px;
}
.btn11 /deep/ .grid-text1 {
  font-size: 12px;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  width: 100%;
  text-align: center;

  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.card_swipe {
  width: 100%;
  margin-top: 8px;
  > .card_swipe_s {
    min-height: 150px;
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
}
.content-zd {
  font-size: 13px;
  margin: 6px 0px 0px;
  opacity: 0.5;
}
.card_swipe /deep/ .van-swipe__indicators {
  bottom: 20px;
}
.xbox1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.xcx_icon {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  opacity: 0;
}
</style>